import { Tabs, Tab, Typography, Box } from "@mui/material";
import { soonBadge } from "../../Layouts/CommunityLayout/styles/styles";
import { useTranslation } from "react-i18next";

const CustomFilterTabs = ({ tabs, activeTab, onChange, tabItemStyles }) => {
  const { t } = useTranslation("bottom-menu-and-settings");
  const styles = {
    tabsContainer: {
      minHeight: "auto",
      "& .MuiTabs-indicator": {
        display: "block",
        height: "2px",
        backgroundColor: "rgba(37, 124, 109, 1)",
      },
      "& .MuiTabs-scroller": {
        overflowX: "auto !important",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        scrollbarWidth: "none",
      },
    },

    tab: {
      minHeight: "auto",
      padding: "0px",
      paddingBottom: "12px",
      paddingTop: "8px",
      paddingX: "8px",
      borderRadius: "50px",
      minWidth: "auto",
      marginRight: "20px",
      fontSize: "15px",
      fontWeight: 600,
      textTransform: "capitalize",
      color: "rgba(62, 63, 76, 1)",
      opacity: 1,
      transition: "all 0.2s ease-in-out",
      "& span": {
        fontSize: "15px",
        fontWeight: 600,
        color: "rgba(62, 63, 76, 1)",
      },
      "&.Mui-selected": {
        color: "rgba(37, 124, 109, 1)",
        "&:hover": {
          backgroundColor: "transparent",
          color: "rgba(37, 124, 109, 1)",
        },
        "& span": {
          color: "rgba(37, 124, 109, 1)",
        },
      },
      "&:hover": {
        backgroundColor: {
          xs: "transparent",
          md: "rgba(36, 139, 112, 0.15)",
        },
        color: {
          xs: "rgba(36, 139, 112, 1)",
          md: "rgba(36, 139, 112, 0.8)",
        },
      },
      "&.Mui-disabled": {
        opacity: 0.5,
      },
    },

    icon: (selected, disabled) => ({
      width: 20,
      height: 20,
      opacity: disabled ? 0.6 : 1,
      filter:
        !disabled && selected
          ? "invert(52%) sepia(19%) saturate(902%) hue-rotate(118deg) brightness(92%) contrast(90%)"
          : "none",
    }),
  };

  return (
    <Tabs
      value={activeTab}
      onChange={onChange}
      sx={styles.tabsContainer}
      TabIndicatorProps={{
        style: { backgroundColor: "rgba(37, 124, 109, 1)" },
      }}
      textColor="inherit"
    >
      {tabs.map((tabItem) => {
        const showCount = tabItem.count !== undefined && tabItem.count !== null;

        const labelContent = (
          <Box display="flex" alignItems="center" gap="6px">
            {tabItem.iconPath && (
              <img
                src={tabItem.iconPath}
                alt={tabItem.label}
                style={styles.icon(
                  activeTab === tabItem.value,
                  tabItem.disabled
                )}
              />
            )}
            <Typography component="span">
              {tabItem.label}
              {showCount && ` (${tabItem.count})`}
            </Typography>

            {tabItem.soonBadge && <Box sx={soonBadge}>{t("soon")}</Box>}
          </Box>
        );

        return (
          <Tab
            key={tabItem.value}
            label={labelContent}
            value={tabItem.value}
            sx={{ ...styles.tab, ...tabItemStyles }}
            disabled={tabItem.disabled}
          />
        );
      })}
    </Tabs>
  );
};

export default CustomFilterTabs;
